<template>
  <div>
    <v-col cols="12" md="12" v-if="allOrders.length > 0">
      <v-card
        class="p-3 orders mb-4"
        v-for="(list, index) in allOrders"
        :key="index"
      >
        <router-link :to="{ name: 'ordersDetails', params: { id: list.id } }">
          <div
            class="_top d-flex justify-content-between align-center flex-row flex-wrap"
          >
            <p>{{ list.category_title }}</p>
            <p>
              <v-icon small> mdi-clock-outline </v-icon>
              <span> {{ list.humantime }} </span>
            </p>
          </div>
          <div class="_title">
            <v-card-title> {{ list.description }} </v-card-title>
          </div>
          <div
            class="_info d-flex justify-content-start align-start flex-row flex-wrap gap-4 w-100 mt-4"
          >
            <p class="_id"><v-icon> mdi-pound </v-icon> {{ list.id }}</p>
            <p class="_name">
              <v-icon> mdi-account </v-icon> {{ list.member_name }}
            </p>
            <p class="_location">
              <v-icon> mdi-map-marker-radius </v-icon> {{ list.city }}
            </p>
            <p class="_date">
              <v-icon> mdi-calendar-range </v-icon>
              {{ list.display_date }}
            </p>
            <p class="_status">
              <v-icon> mdi-cog-outline </v-icon> {{ list.status }}
            </p>
          </div>
        </router-link>
      </v-card>
    </v-col>
    <div class="" v-else>
      <v-row>
        <v-col cols="12" md="12">
          <v-skeleton-loader
            class="mx-auto"
            type="list-item-three-line , list-item-three-line , actions"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader
            class="mx-auto"
            type="list-item-three-line , list-item-three-line , actions"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader
            class="mx-auto"
            type="list-item-three-line , list-item-three-line , actions"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allOrders: {
      type: Array,
    },
    typeOrder: {
        type: String
    }
  },
};
</script>


<style lang="scss" scoped>
.orders {
  ._top {
    p {
      color: #868e96;
      margin-bottom: 5px;
    }
  }
  ._title {
    .v-card__title {
      padding: 0;
      color: #212529;
      font-size: 18px;
      text-align: start
    }
  }
  ._info {
    p,
    i {
      color: #4d4d4d;
      font-weight: 500;
      font-size: 16px;
    }
    i {
      font-size: 22px;
    }
  }
}

.v-card {
  box-shadow: none !important;
  border: 1px solid #e8e9ea;
  border-color: #e8e9ea !important;
}
</style>

